import agusta from "@public/img/um-okkur/board-members/agusta.webp";
import bjarki from "@public/img/um-okkur/employees/bjarki.webp";
import victor from "@public/img/um-okkur/employees/victor.webp";
import finnbogi from "@public/img/um-okkur/employees/finnbogi.webp";
import rahmon from "@public/img/um-okkur/employees/rahmon.webp";
import musso from "@public/img/um-okkur/employees/musso.webp";
import bergthor from "@public/img/um-okkur/employees/bergthor.webp";
import thura from "@public/img/um-okkur/employees/thura.jpg";
import ari from "@public/img/um-okkur/employees/ari.png";
import asthildur from "@public/img/um-okkur/employees/asthildur.jpg";

const BOARD_MEMBERS = [
    {
        image: bjarki,
        name: "Bjarki Pétursson",
        position: "Framkvæmdastjóri",
    },
    {
        image: agusta,
        name: "Ágústa Finnbogadóttir",
        position: "Fjármálastjóri",
    },
    {
        image: thura,
        name: "Þuríður St. (Þura)",
        position: "Ráðgjafi og Verkefnastjóri",
    },
    {
        image: victor,
        name: "Victor Pálmarsson",
        position: "Þjónustustjóri",
    },
    {
        image: finnbogi,
        name: "Finnbogi Arnar Strange",
        position: "Þjónustuver",
    },
    {
        image: rahmon,
        name: "Rahmon Anvarov",
        position: "Tæknistjóri",
    },
    {
        image: musso,
        name: "Musso Mirkholov",
        position: "Forritari",
    },
    {
        image: bergthor,
        name: "Bergþór Þrastarson",
        position: "Forritari",
    },
    {
        image: ari,
        name: "Ari S. Arnarsson",
        position: "Grafískur hönnuður",
    },
    {
        image: asthildur,
        name: "Ásthildur Bertha",
        position: "Stúdentar taka til",
    },
];

export default BOARD_MEMBERS;
